import { useEffect, useState } from 'react';
import { OrderAcceptPage } from './seller/OrderAcceptPage';
import { DesktopOrderAcceptPage } from './desktop/DesktopOrderAcceptPage';

export function ResponsiveOrderAcceptPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile ? <OrderAcceptPage /> : <DesktopOrderAcceptPage />;
}